import { lazy } from "react";
// Tools — hub de mini-apps. Cada app vive en ./Apps/<App> y publica su ruta
// de primer nivel acá; el hub (/Tools) es solo la pantalla de menú.
const Tools = lazy(() => import("./Tools"));
const CoddingOpportunities = lazy(() => import("./Apps/Coders/CoddingOpportunities/CoddingOpportunities"));
const AddOn = lazy(() => import("./Apps/AddOn/AddOn"));
const PrePostAudi = lazy(() => import("./Apps/Pre&PostAudi/PrePostAudi"));
const AHCA = lazy(() => import("./Apps/AHCA/AHCA"));
const PCPChanges = lazy(() => import("./Apps/PCPChanges/PCPChanges"));
const NewMember = lazy(() => import("./Apps/NewMember/NewMember"));
const ACAAging6265 = lazy(() => import("./Apps/ACAAging6265/ACAAging6265"));
const ACAAging65 = lazy(() => import("./Apps/ACAAging65/ACAAging65"));
const PostVisit = lazy(() => import("./Apps/PostVisit/PostVisit"));
const WelcomeCampaign = lazy(() => import("./Apps/WelcomeCampaign/WelcomeCampaign"));
export const toolsRoutes = [
  { path: "/Tools", element: <Tools /> },
  { path: "/CoddingOpportunities", element: <CoddingOpportunities /> },
  { path: "/AddOn", element: <AddOn /> },
  { path: "/PrePostAudi", element: <PrePostAudi /> },
  { path: "/AHCA", element: <AHCA /> },
  { path: "/PCPChanges", element: <PCPChanges /> },
  { path: "/NewMember", element: <NewMember /> },
  { path: "/ACAAging6265", element: <ACAAging6265 /> },
  { path: "/ACAAging65", element: <ACAAging65 /> },
  { path: "/PostVisit", element: <PostVisit /> },
  { path: "/WelcomeCampaign", element: <WelcomeCampaign /> },
];

export { Tools };
